// Simple Cart Drawer Test - Only runs when ?test=true is in URL
(function () {
  "use strict";

  // Only run if test parameter is present
  if (!window.location.search.includes("test=true")) {
    return;
  }

  console.log("🧪 Simple Cart Test Running...");

  // Wait for page to load
  function runTest() {
    const cartDrawer = document.querySelector("cart-drawer");
    const buyNowBtn = document.querySelector(".product-form__submit");

    console.log("Cart drawer element:", cartDrawer);
    console.log("Buy now button:", buyNowBtn);

    if (!cartDrawer) {
      console.error("❌ Cart drawer not found");
      return;
    }

    if (!buyNowBtn) {
      console.error("❌ Buy now button not found");
      return;
    }

    console.log("✅ Elements found");

    // Check if button is disabled
    const isDisabled =
      buyNowBtn.hasAttribute("disabled") ||
      buyNowBtn.getAttribute("aria-disabled") === "true";
    console.log("Button disabled:", isDisabled);

    // Check button text
    const buttonText = buyNowBtn.querySelector("span")?.textContent?.trim();
    console.log("Button text:", buttonText);

    // Check cart drawer state
    const isActive = cartDrawer.classList.contains("active");
    console.log("Cart drawer active:", isActive);

    // Check Safari
    const isSafari =
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      /Safari/.test(navigator.userAgent);
    console.log("Is Safari:", isSafari);
    console.log("User Agent:", navigator.userAgent);

    // Test network connectivity
    console.log("Testing network connectivity...");
    fetch("/cart.js")
      .then((response) => {
        console.log("✅ Network test successful:", response.status);
      })
      .catch((error) => {
        console.error("❌ Network test failed:", error);
      });

    // Add test buttons
    const testBtn = document.createElement("button");
    testBtn.textContent = "Test Cart";
    testBtn.style.cssText = `
      position: fixed;
      top: 10px;
      right: 10px;
      z-index: 10000;
      padding: 10px;
      background: #007cba;
      color: white;
      border: none;
      border-radius: 5px;
      font-size: 14px;
    `;

    testBtn.onclick = () => {
      console.log("Test button clicked");
      if (typeof cartDrawer.open === "function") {
        cartDrawer.open();
        console.log("Cart drawer opened");
      } else {
        console.error("Cart drawer open method not found");
      }
    };

    const testAddBtn = document.createElement("button");
    testAddBtn.textContent = "Test Add to Cart";
    testAddBtn.style.cssText = `
      position: fixed;
      top: 50px;
      right: 10px;
      z-index: 10000;
      padding: 10px;
      background: #28a745;
      color: white;
      border: none;
      border-radius: 5px;
      font-size: 14px;
    `;

    testAddBtn.onclick = () => {
      console.log("Test add to cart clicked");

      // Simulate the cart add request
      const formData = new FormData();
      const variantId = document.querySelector("input[name='id']")?.value;
      if (!variantId) {
        console.error("No variant ID found");
        return;
      }

      formData.append("id", variantId);
      formData.append("quantity", "1");
      formData.append("sections", "cart-drawer");
      formData.append("sections_url", window.location.pathname);

      console.log("Sending cart add request...");
      console.log("Variant ID:", variantId);

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json, text/plain, */*",
          "Cache-Control": "no-cache",
        },
        credentials: "same-origin",
        body: formData,
      })
        .then((response) => {
          console.log("Response status:", response.status);
          console.log("Response ok:", response.ok);
          return response.json();
        })
        .then((data) => {
          console.log("✅ Cart add successful:", data);
          if (cartDrawer && typeof cartDrawer.renderContents === "function") {
            cartDrawer.renderContents(data);
          }
        })
        .catch((error) => {
          console.error("❌ Cart add failed:", error);
          console.error("Error details:", {
            name: error.name,
            message: error.message,
            stack: error.stack,
          });
        });
    };

    document.body.appendChild(testBtn);
    document.body.appendChild(testAddBtn);

    console.log(
      '🧪 Test setup complete. Click the blue "Test Cart" button to test cart drawer, or green "Test Add to Cart" to test adding items.'
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runTest);
  } else {
    runTest();
  }
})();
